import { render, staticRenderFns } from "./Andikator.vue?vue&type=template&id=ffb12f02&scoped=true"
import script from "./Andikator.vue?vue&type=script&lang=js"
export * from "./Andikator.vue?vue&type=script&lang=js"
import style0 from "./Andikator.vue?vue&type=style&index=0&id=ffb12f02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb12f02",
  null
  
)

export default component.exports